import { render, staticRenderFns } from "./analyticsNCRDashboard.vue?vue&type=template&id=237ab16e&"
import script from "./analyticsNCRDashboard.vue?vue&type=script&lang=js&"
export * from "./analyticsNCRDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports